(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabDevicesTypesDeleteController',TabDevicesTypesDeleteController);

    TabDevicesTypesDeleteController.$inject = ['$uibModalInstance', 'entity', 'TabDevicesTypes'];

    function TabDevicesTypesDeleteController($uibModalInstance, entity, TabDevicesTypes) {
        var vm = this;
        vm.tabDevicesTypes = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TabDevicesTypes.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
